var TechnologyDetail = /** @class */ (function () {
    function TechnologyDetail() {
    }
    TechnologyDetail.getPageTechnology = function () {
        return document.body.dataset["technology"] || null;
    };
    TechnologyDetail.getTechnologyDetails = function (technology) {
        return this.technologies.hasOwnProperty(technology)
            ? this.technologies[technology]
            : null;
    };
    TechnologyDetail.technologies = {
        FTTP: {
            name: "Fibre to the Premises (FTTP)",
            link: "https://www.aussiebroadband.com.au/?utm_source=SkyMesh&utm_medium=referral&utm_campaign=Fixed-Line-traffic",
            refer_to_partner: true,
            code: 'FTTP',
        },
        FTTN: {
            name: "Fibre to the Node (FTTN)",
            link: "https://www.aussiebroadband.com.au/?utm_source=SkyMesh&utm_medium=referral&utm_campaign=Fixed-Line-traffic",
            refer_to_partner: true,
            code: 'FTTN',
        },
        FTTB: {
            name: "Fibre to the Building (FTTB)",
            link: "https://www.aussiebroadband.com.au/?utm_source=SkyMesh&utm_medium=referral&utm_campaign=Fixed-Line-traffic",
            refer_to_partner: true,
            code: 'FTTB',
        },
        FTTC: {
            name: "Fibre to the Curb (FTTC)",
            link: "https://www.aussiebroadband.com.au/?utm_source=SkyMesh&utm_medium=referral&utm_campaign=Fixed-Line-traffic",
            refer_to_partner: true,
            code: 'FTTC',
        },
        HFC: {
            name: "Hybrid Fibre Coaxial",
            link: "https://www.aussiebroadband.com.au/?utm_source=SkyMesh&utm_medium=referral&utm_campaign=Fixed-Line-traffic",
            refer_to_partner: true,
            code: 'HFC',
        },
        WIRELESS: {
            name: "Fixed Wireless",
            link: "/nbn-services/fixed-wireless/#plans",
            refer_to_partner: false,
            code: 'WIRELESS',
        },
        SATELLITE: {
            name: "Sky Muster™",
            link: "/nbn-services/sky-muster/#plans",
            refer_to_partner: false,
            code: 'SATELLITE',
        },
        REDTRAIN: {
            name: "Redtrain",
            link: "/redtrain/",
            refer_to_partner: true,
            code: 'REDTRAIN',
        }
    };
    return TechnologyDetail;
}());
export { TechnologyDetail };
